import { ICUserArea } from "./icuserarea";
import { ICUserRole } from "./icuserrole";
import { UserRole } from "./userrole";

export class ICUser {
  Code: string;
  CompleteName: string;
  DeleteDate: string;
  Email: string;
  Enabled: boolean;
  ICUserRoles: ICUserRole[];
  Id: number;
  IdGuid: string;
  InsertDate: string;
  LastEditDate: string;
  LastLogin: string;
  Name: string;
  Password: string;
  Surname: string;
  UserAreas: ICUserArea[];
  Username: string;
  UserRoles: UserRole[];

  constructor(data?: Partial<ICUser>) {
    Object.assign(this, data);
  }
}
